import Main from './Main'
import Lista from './components/ServicoLista'
import Novo from './components/NovoServico'

export default [
  {
    path: 'servicos',
    name: 'policiacivil.processo.servicos',
    component: Main,
    redirect: { name: 'policiacivil.processo.servicos.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.servicos.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.servicos.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.servicos.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/servicos/routes.js